module.exports = __webpack_public_path__ + "img/south-sudan.6d86c1ea.svg";